import React from 'react';

class ListErrors extends React.Component {
  render() {
    const errors = this.props.errors;
    if (errors) {
      return (
        Object.keys(errors).map(key => {
          return (
            <div className="error-messages" key={key}>{errors[key].message || errors[key]}</div>
          )
        })
      );
    } else {
      return null;
    }
  }
}

export default ListErrors;



// WEBPACK FOOTER //
// ./src/components/ListErrors.js